/**
 * Primitive Typography Tokens
 *
 * Raw typography values from the Figma design system.
 * These are composed into semantic typography tokens in semantic/typography.ts
 */

export const fontFamilies = {
  standard: "Inter",
  numbers: "archivo",
} as const;

export const fontSizes = {
  "9": 9,
  "11": 11,
  "12": 12,
  "13": 13,
  "14": 14,
  "16": 16,
  "18": 18,
  "20": 20,
  "22": 22,
  "24": 24,
  "26": 26,
  "28": 28,
  "34": 34,
  "36": 36,
  "44": 44,
  "56": 56,
} as const;

export const fontWeights = {
  regular: "400",
  medium: "500",
  semiBold: "600",
  bold: "700",
} as const;

export const lineHeights = {
  "12": 12,
  "14": 14,
  "16": 16,
  "18": 18,
  "20": 20,
  "24": 24,
  "26": 26,
  "28": 28,
  "32": 32,
  "36": 36,
  "40": 40,
  "44": 44,
  "64": 64,
} as const;

export const letterSpacings = {
  none: 0,
  tight1: -0.1,
  tight3: -0.5,
  wide2: 0.2,
  wide4: 2,
} as const;

export type FontFamily = keyof typeof fontFamilies;
export type FontSize = keyof typeof fontSizes;
export type FontWeight = keyof typeof fontWeights;
export type LineHeight = keyof typeof lineHeights;
export type LetterSpacing = keyof typeof letterSpacings;
